import React, { useState, useEffect } from 'react';
import { formatDate, formatTime } from '../utils/timeUtils';
import '../styles/Header.css';

const Header: React.FC = () => {
  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="header">
      <h1>Time Trakr Lite</h1>
      <div className="date-time">
        <div className="date">{formatDate(currentTime)}</div>
        <div className="time">{formatTime(currentTime)}</div>
      </div>
    </div>
  );
};

export default Header;
